import { useState } from 'react';

export default function useDnd<T>(movableItems: T[]) {
  const [items, setItems] = useState(movableItems);

  const moveInsertCardHandler = (dragIndex: number, hoverIndex: number) => {
    const dragItem = items[dragIndex];

    if (dragItem) {
      setItems(prevState => {
        const coppiedStateArray = [...prevState];

        if (dragIndex === hoverIndex) return coppiedStateArray;

        const beforeItem = coppiedStateArray.slice(0, dragIndex);
        const afterItem = coppiedStateArray.slice(dragIndex + 1);

        if (dragIndex < hoverIndex) {
          const targetIndex = hoverIndex - dragIndex;
          const result = [
            ...beforeItem,
            ...afterItem.slice(0, targetIndex),
            coppiedStateArray[dragIndex],
            ...afterItem.slice(targetIndex),
          ];

          return result;
        } else {
          const targetIndex = hoverIndex;

          const result = [
            ...beforeItem.slice(0, targetIndex),
            coppiedStateArray[dragIndex],
            ...beforeItem.slice(targetIndex),
            ...afterItem,
          ];

          return result;
        }
      });
    }
  };

  return { items, setItems, moveInsertCardHandler };
}
